export default "__VITE_ASSET__tdmWz7XA__"